import React from "react";
import Box from "@amzn/meridian/box";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";

interface VolumeTargetDisplayProps {
    totalTargetVolume?: number
}

const VolumeTargetDisplay: React.FC<VolumeTargetDisplayProps> = ({
    totalTargetVolume
}) => {
    return(
        <Box type={"outline"} spacingInset={"300"} className="volume-target-display">
            <Column spacing={"200"}>
                <Text type={"h200"}>ALPS Target</Text>
                <Row spacing={"400"}>
                    <Column spacing={"100"} alignmentHorizontal={"start"}>
                        <Text type={"d50"}>{totalTargetVolume || "--"}</Text>
                    </Column>
                </Row>
            </Column>
        </Box>
    );
};

export default VolumeTargetDisplay;
